import React, { FunctionComponent, ReactNode } from 'react';
import { Typography } from '@mui/material';
import cx from 'classnames';
import useStyles from './Copyright.styles';

interface IProps {
  color?: 'blue';
  customClass?: string;
  children: ReactNode;
}

const Copyright: FunctionComponent<IProps> = ({
  color,
  customClass = '',
  children,
}) => {
  const classes = useStyles();

  return (
    <Typography
      className={cx(
        classes.text,
        color && classes[color],
        customClass
      )}
    >
      {children}
    </Typography>
  );
};

export default Copyright;
